import { render, staticRenderFns } from "./DynamicTitle.vue?vue&type=template&id=4cb82c28&scoped=true"
import script from "./DynamicTitle.vue?vue&type=script&lang=js"
export * from "./DynamicTitle.vue?vue&type=script&lang=js"
import style0 from "./DynamicTitle.vue?vue&type=style&index=0&id=4cb82c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb82c28",
  null
  
)

export default component.exports